export default __webpack_public_path__ + "static/media/phone.12c51cb2.svg";